import React from "react";

import { Box } from "@mui/material";

import Carousel from "../components/Carousel";
import Jumborton from "../components/Jumborton";
import Categories from "../components/Categories";
import SponsorsBar from "../components/SponsorsBar";
import ScrollTracker from "../general-components/ScrollTracker";

const Home = ({ categoriesData, eventsData, sponsorsData }) => {
  return (
    <ScrollTracker
      eventProperties={{
        page: "home",
      }}
      threshold={0.5}
    >
      <Jumborton />
      <Box sx={{ mt: 4 }}>
        <Carousel list={eventsData} />
      </Box>
      <Box sx={{ mt: 7 }}>
        <Categories categoriesData={categoriesData} />
      </Box>
      <Box sx={{ mt: 7 }}>
        <SponsorsBar sponsorsData={sponsorsData} />
      </Box>
    </ScrollTracker>
  );
};

export default Home;
